import {
  Button,
  Form,
  Formik,
  FormikControl,
  Field,
  InputError,
  Tooltip,
  InfoIcon,
  InputModalConstants,
  Link,
  initialiseLiveAuthClient,
  InputModalStyle,
  FormModalStyle,
  Close,
  useState,
  useRef,
  integrationValidationSchema,
} from "@/imports-files/components/model/custom-company-integration-modal";

export function InputModal({
  closeState,
  heading,
  description,
  inputs,
  radios,
  onSubmit,
  modalHeight,
  initialValues,
  setFormData,
  links,
  selectedItem,
  connectModal,
  selectedRadio,
  setSelectedRadio,
}) {


  const [isAccountConnected, setIsAccountConnected] = useState(false); 

  const handleRadioChange = (value, formik) => {
    setSelectedRadio(value);
    if (value === "false") {
      formik.setFieldValue("contract_id", "");
      formik.setFieldValue("company_id", "");
    } else {
      formik.setFieldValue("contract_id", "");
      formik.setFieldValue("company_id", "");
    }
  };
  const formRef = useRef(null);
  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal} ${modalHeight}`}>
        <div className={`${FormModalStyle.Modal__Container} `}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => closeState(false)}
          >
            <Close />
            CLOSE
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
            <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              {heading}
            </h1>
            <div
              className={`${FormModalStyle.Modal__Container__ContentSection__Description}`}
            >
              {description}
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={integrationValidationSchema(
                isAccountConnected,
                connectModal,
                selectedRadio
              )}
              innerRef={formRef}
              // onSubmit={(values) => {
              //   setFormData(values);
              //   onSubmit();
              // }}
              onSubmit={(values) => {
                const jobdata = {};
  
                if (connectModal === "indeed") {
                  jobdata.company_name = values.company_name;
                  if (values.campaign_tag) {
                    jobdata.campaign_tag = values.campaign_tag;
                  }
                } else if (connectModal === "linkedInJobs") {
                  jobdata.company_id = values.company_id;
                  if (selectedRadio === "false" && values.contract_id) {
                    jobdata.contract_id = values.contract_id;
                  }
                }
                if (connectModal === "linkedInJobs") {
                  jobdata.company_id = values.company_id;
                  if (selectedRadio === "false" && values.contract_id) {
                    jobdata.contract_id = values.contract_id;
                  }
                }
                if (connectModal === "totalJobs") {
                  jobdata.user_name = values.user_name;
                  if (values.password) {
                    jobdata.password = values.password;
                  }
                }
  
                setFormData(jobdata);
                onSubmit();
              }}
            >
              {(formik) => (
                <Form
                  className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                >
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block__radioBtn}  mb20`}
                  >
                    {radios?.map((radio, index) => {
                      return (
                        <>
                          <div key={index}>
                            <label
                              className={`Dpflex WrapperRadioContainer WrapperRadiocheckmarkfont mb0`}
                            >
                              <Field
                                type="radio"
                                name="radio"
                                id={radio.id}
                                value={radio.defaultvalue}
                                // checked={radio.checked}
                                checked={selectedRadio === radio.defaultvalue}
                                // onChange={() =>
                                //   setSelectedRadio(radio.defaultvalue)
                                // }
                                onChange={() =>
                                  handleRadioChange(radio.defaultvalue, formik)
                                }
                              />
                              <span
                                style={{ marginTop: "2px" }}
                                className="WrapperRadiocheckmark"
                              ></span>{" "}
                              <span className={`ml5 mt-0`}>
                                {radio.text}
                              </span>
                            </label>
                          </div>
                        </>
                      );
                    })}
                  </div>

                  {inputs?.map((input, index) => {
                    if (
                      input.name === "contract_id" &&
                      selectedRadio !== "false"
                    ) {
                      return null;
                    }
                    return (
                      <>
                        <div key={index}>
                          <div
                            className={`
                              ${FormModalStyle.Modal__Container__ContentSection__Block__flexAlign}
                             `}
                          >
                            <label
                              className={`
                              ${FormModalStyle.Modal__Container__ContentSection__Block__Heading}
                             `}
                            >
                              {input.label}{" "}
                              {!["campaign_tag"].includes( input.name ) && " *"}
                              {input.tooltip && (
                                <span
                                  className={
                                    FormModalStyle.Modal__Container__ContentSection__Block__Tooltip
                                  }
                                >
                                  <Tooltip
                                    content={input.tooltip}
                                    {...InputModalConstants.tooltip}
                                    className={`SimpleTooltip`}
                                  >
                                    <p
                                      className={`tooltipwidth270 SimpleTooltip`}
                                    >
                                      <InfoIcon />
                                    </p>
                                  </Tooltip>
                                </span>
                              )}
                            </label>

                            {["contract_id"].includes(input.name) &&
                            selectedRadio === "false" && (
                              <>
                                <button
                                  className={`
                              ${FormModalStyle.Modal__Container__ContentSection__Block__flexAlign__btn} `}
                                  // onClick={(e) => {
                                  //   initialiseLiveAuthClient(
                                  //     e,
                                  //     formik,
                                  //     selectedItem.idibu_data
                                  //   );
                                  // }}                                  
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    const errors = await formik.validateForm();
                                    // if (errors.contract_id) {
                                    //   formik.setFieldTouched("contract_id", true);
                                    //   return;
                                    // }
                                    initialiseLiveAuthClient(
                                      e,
                                      formik,
                                      selectedItem.idibu_data,
                                      setIsAccountConnected
                                    );
                                    // setIsAccountConnected(true);
                                  }}
                                >
                                  {" "}
                                  connect an account
                                </button>
                              </>
                            )}
                          </div>

                          {input.description && (
                            <>
                              <div
                                className={`${FormModalStyle.Modal__Container__ContentSection__Description} mt0 mb10`}
                              >
                                {{
                                  obtainContractId: (
                                    <>
                                      {/* To obtain your Contract ID, kindly{" "}
                                      <span
                                        className={`${InputModalStyle.ModalInput__Link} ${FormModalStyle.Modal__Container__ContentSection__Description__Link}`}
                                        onClick={(e) => {
                                          initialiseLiveAuthClient(e, formik);
                                        }}
                                      >
                                        <Link
                                          onClick={(e) =>
                                            initialiseLiveAuthClient(e, formik)
                                          }
                                          href="#"
                                        >
                                          click here
                                        </Link>
                                      </span>{" "}
                                      and it will be automatically fetched and
                                      displayed. */}

                                      <span>
                                        To obtain your Contract ID, kindly click the "Connect an account" and it will be automatically fetched and displayed.
                                      </span>
                                    </>
                                  ),
                                  obtainCompanyId: (
                                    <>
                                      To obtain your Company ID, please refer to
                                      the{" "}
                                      <span
                                        className={
                                          FormModalStyle.Modal__Container__ContentSection__Description__Link
                                        }
                                      >
                                        <a
                                          href="https://www.linkedin.com/help/linkedin/answer/a415420"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          guide here
                                        </a>
                                      </span>{" "}
                                      for step-by-step instructions on how to
                                      access and view it.
                                    </>
                                  ),
                                }[input.description] || input.description}
                              </div>
                            </>
                          )}
                        </div>

                        <div
                          className={InputModalStyle.ModalInput__Form__Table}
                        >
                          <FormikControl
                            control="input"
                            formik={formik}
                            // type="text"
                            {...input}
                          // disabled={
                          //   (input.name == "contract_id" &&
                          //     contractFieldDisabled) ||
                          //   input.disabled
                          // }
                            disabled={
                              input.name === "contract_id" && !isAccountConnected
                            }
                            className={`width80 ${InputModalStyle.Form__Input}`}
                            errorClass={InputModalStyle.Form__error}
                            style={InputError(formik, input.name)}
                            onBlur={() =>
                              formik.setFieldTouched(input.name, true)
                           }
                        />
                        </div>
                      </>
                    );
                  })}
                  {links?.map((link, index) => (
                    <div
                      className={InputModalStyle.ModalInput__Link}
                      key={index}
                      onClick={(e) => {
                        if (link.onClick) {
                          link.onClick(e);
                        } else if (link.initialiseLiveAuthClient) {
                          initialiseLiveAuthClient(e, formik);
                        }
                      }}
                    >
                      <Link href={link.url}>{link.label}</Link>
                    </div>
                  ))}
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={InputModalStyle.secondarybtn}
                      onClick={() => {
                        closeState(false);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      buttonstyle={InputModalStyle.primarybtn}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
